import { useQuery } from '@tanstack/react-query';

import type { LvaProactiveSummary } from '@dcc-erp/shared';

import { api } from '../api';

// ============================================================
// LVA Phase E — proactive scheduling / alerts summary. Mirrors
// lib/queries/lva-report.ts (api() + companyId-scoped cache keys +
// optional query param). Read-only: the server endpoint enriches each
// IN_USE register item with cycle-count / warranty / replacement signals
// and tallies overdue count rounds — no mutation, so nothing to invalidate.
// asOf (YYYY-MM-DD) overrides the "today" the server reckons due-ness from.
// ============================================================

export function useLvaProactive(companyId: string | undefined, asOf?: string) {
  return useQuery({
    queryKey: ['lva-proactive', companyId, asOf] as const,
    queryFn: () =>
      api<LvaProactiveSummary>(
        `/companies/${companyId}/lva-items/proactive${asOf ? `?asOf=${asOf}` : ''}`,
      ),
    enabled: !!companyId,
  });
}
